import { BEFORE_ENTRY_LABEL } from "@/features/talent/constants/form";

/**
 * Schema field labels mapping for talent form.
 * Used to strip label prefixes from parsed values (e.g., "氏名: value" → "value").
 * Labels must match exactly with .label() definitions in useGetTalentSchema.
 * Values can be a single string or an array of strings (aliases) for fields that accept multiple label formats.
 */
export const TALENT_SCHEMA_LABELS: Record<string, string | string[]> = {
  // Basic info
  full_name: "氏名",
  birthday: "生年月日",
  nick_name: "呼び名",
  talent_number: "人材管理番号",
  nationality: "国籍",
  gender: "性別",
  phone_number: "電話番号",
  email: ["メールアドレス", "メール"],
  religion: "宗教",
  location: "居住地",

  // Address
  zip_code: "郵便番号",
  prefecture: "都道府県",
  city: "市区町村",
  address: "町名丁目番地号等",
  country: "国・地域",

  // Visa/Passport
  period_of_stay: "在留期限",
  is_before_entry: BEFORE_ENTRY_LABEL,
  specified_skill_first_start_date: "特定技能1号起算日",
  blank_period_monthly: "ブランク期間（月単位）",
  specified_skill_first_remaining_term: "特定技能1号残存期間",
  passport_number: "パスポート番号",
  passport_expiry_date: "パスポート期限",
  residence_status: "在留資格",

  // Skills/Qualifications
  education_background: "学歴",
  "education_background.education_level": "学歴",
  "education_background.school_name": "学校名",
  "education_background.country": "国名",
  held_qualifications: "資格",
  language_test_other: "日本語能力（その他）",
  specific_skill_certificates: "特定技能合格証等",
  company_specific_industry: "分野",
  specific_business_classification_ids: "区分",
  major: "技能実習　職種",
  job_type: "作業",

  // Work experience (nested)
  "work_experiences.job_type": "職種",
  "work_experiences.company_name": "企業名",

  // Other info
  memo: "特性メモ",
  interview_evaluation: "面談評価",
  family_information: "家族構成",
  desired_job_type_ids: "希望職種（分野）",
  contact_type: "その他の連絡手段、SNS",
  contact_info: "その他の連絡先ID等",
  desired_work_location: "希望勤務地",
  expect_salary: "希望給与",
  available_from: "転職可能時期",
  other_request: "その他希望",
  internal_memo: "社内メモ",
  interview_date: "面談日",
};

/**
 * Get primary label for a schema field key.
 * Returns the first label if multiple aliases exist.
 */
export const getSchemaLabel = (fieldKey: string): string => {
  const label = TALENT_SCHEMA_LABELS[fieldKey];
  if (!label) return "";
  return Array.isArray(label) ? label[0] : label;
};

/**
 * Get all labels (aliases) for a schema field key.
 */
export const getSchemaLabels = (fieldKey: string): string[] => {
  const label = TALENT_SCHEMA_LABELS[fieldKey];
  if (!label) return [];
  return Array.isArray(label) ? label : [label];
};
